<template>
  <VCard>
    <VCardTitle class="justify-center"
      >Terms of Sale - Refund Policy</VCardTitle
    >
    <VCardText class="break-word">
      <p>Effective Date: 07/21/2019</p>
      <p>________________________________________</p>
      <p>PURCHASE, PRICE INFORMATION, PAYMENT TERMS AND REFUND POLICY</p>
      <p>
        (a) <span class="font-italic">Subscription</span>. Certain aspects of
        the Services provided by Aestell, third parties, or both may require you
        to purchase a subscription for a period of time as specified during
        sign-up (collectively a “Subscription”). Your Subscription, which may
        start with a thirty (30) day trial period, will automatically renew on a
        monthly or annual basis (as specified during your sign-up) unless you
        cancel your Subscription as provided in Sections 3(e) and 3(g), or we
        terminate your Subscription as provided below.
      </p>
      <p>
        • We may terminate this Agreement and close your account, or suspend
        your access to the Services, at any time without notice and without
        responsibility or liability to you, in the event of your actual or
        suspected unauthorized use or misuse of the Services and/or Service
        Content, or breach of the Agreement. In that event, we will refund to
        you a pro-rata share of your Subscription charge to account for the
        period you will not be able to access the Services.
      </p>
      <p>
        • We may terminate this Agreement and close your account at any time on
        reasonable notice to you if we cease to provide the Services.
      </p>
      <p>
        (b) <span class="font-italic">Bundles</span>. Aestell may contract with
        a third-party telecommunication provider to provide the Services to you
        through a bundle package together with other services provided by such
        third party provider. The payment terms for such bundle package, as well
        as other terms and conditions governing your use of the bundle package,
        may differ from the terms set out in this Agreement. You are solely
        responsible for reviewing such bundle terms or any other terms governing
        your use of the services provided by your telecommunication provider
        before agreeing to any bundle package and accessing the Service via such
        bundle package. If you have purchased a bundle package, payment will be
        taken from you by your telecommunication provider. Should you wish to
        cancel or terminate your subscription via such bundle package or obtain
        any further information in respect of payment methods, billing cycles,
        automatic renewals or refunds you must contact your provider. Other than
        this sub-section (b), Section 3 of this Agreement does not apply to you
        if you have purchased the Services as part of a bundle package from any
        other third party.
      </p>
      <p>
        (c) <span class="font-italic">Promotion/Trials</span>. Aestell, vendors,
        or other third parties with whom we contract to provide the Services may
        offer special promotions/trials with differing conditions and
        limitations which may be subject to different terms from these Terms.
        Any additional terms to these Terms will be disclosed at sign-up or in
        other communications made available to you prior to sign-up. You are
        solely responsible for reviewing any additional terms governing your use
        of such special promotions or trials before accessing any special
        promotions or trials. At the end of the free or promotional trial
        period, your subscription will automatically renew for further rolling
        subscription periods of such duration as set out in the product details
        when you signed up for the trial or promotion and you will start to pay
        for the subscription. To avoid any charges, you must cancel before the
        end of the free trial. You are entitled to only one free trial per
        lifetime. Any attempt to utilize more than one free trial is an
        unauthorized use of the Services and/or Service Content and amounts to a
        breach of the Agreement. If Aestell determines, in its absolute
        discretion, that you have utilized more than one free trial, Aestell
        reserves the right to terminate your access to the Services, Service
        Content, and/or the Agreement.
      </p>
      <p>
        (d) <span class="font-italic">Purchase</span>. It is not necessary to
        buy a Subscription to make a purchase on the Aestell. To make a store
        purchase, you will be prompted to sign in to your account. If you do not
        have an account, create a free account and choose a username and
        password. Upon completion of the Store purchase, the purchased program
        or resources will appear in your account for download. You can download
        Aestell Store purchases through your aestell.com account. All shopping
        in the Store is final.
      </p>
      <p>
        (e) <span class="font-italic">Payment Methods</span>. In connection with
        any and all Subscriptions that you select to purchase you must provide
        Aestell with a current, valid, accepted method of payment, which may
        change from time to time ("Payment Method"). All Subscription purchases
        are subject to this Agreement and any additional terms and conditions,
        including any fees, imposed by your financial services provider and/or
        mobile carrier, as applicable. You are solely responsible for reviewing
        the terms of use, privacy policy or any other terms governing your use
        of the services provided by your financial services provider and/or
        mobile carrier. By providing a Payment Method in connection with any
        Subscription, you hereby authorize Aestell to debit the total cost of
        said Subscription and agree to be responsible for any foreign
        transaction charges associated with your Subscription purchase. Should
        charges for which you are responsible fail at the time payment is
        required, you may be responsible for costs associated with Aestell’s
        efforts to collect amounts due in accordance with applicable laws. You
        represent and promise to us that all information you provide in
        connection with the purchase of a Subscription is true, accurate and
        complete. The duration and cost of Subscriptions are set by Aestell in
        its sole discretion. When you purchase a Subscription, you will
        initially be charged at the rate applicable at the time of your initial
        agreement to subscribe. If the price of the Subscription increases
        later, we will provide you with written notice before the end of the
        billing period in which the change is made. If you do not accept the
        change to your Subscription, you will be entitled to terminate this
        Agreement.
      </p>
      <p>
        (f) <span class="font-italic">Billing Cycle</span>. As indicated during
        sign-up, the fee for certain Subscriptions must be paid in a single
        upfront payment while other Subscriptions may allow payment on an
        installment basis. If the Subscription fee is paid in a single upfront
        payment, the total Subscription fee is due and payable to Aestell
        immediately upon sale and your Payment Method will be automatically
        billed at that time. If the Subscription fee is paid on an installment
        basis, your Payment Method will automatically be billed at the beginning
        of each installment period as specified during sign-up.
      </p>
      <p>
        (g) <span class="font-italic">Automatic Renewal</span>. In order to
        provide continuous service, you agree that Aestell will automatically
        renew a Subscription on or about the date the Subscription expires. Such
        renewal will be for the same duration of the original subscription term
        and will be billed at the non-discounted rate for the Subscription as of
        the date of your enrollment and according to your original billing cycle
        method (i.e. either as a single upfront payment or an installment
        basis). By enrolling in a Subscription, you agree that your Subscription
        will be subject to the above-described automatic renewals unless you
        cancel your Subscription in accordance with the terms of this Agreement.
        You also agree that the amount billed may be different if your original
        Subscription was purchased using a promotional/trial offer and you
        authorize Aestell to charge your Payment Method for such varying amounts
        as indicated at the time of sign-up. You agree that you are responsible
        for other charges, including any foreign transaction charges, that may
        be imposed by credit card providers, payment processors or other third
        parties in connection with your use of the Subscription. Your
        Subscription will remain in effect and continue to renew automatically
        until it is cancelled.
      </p>
      <p>
        IF YOUR ACCOUNT IS MANAGED THROUGH Aestell (AND NOT THROUGH A THIRD
        PARTY) AND YOU WISH TO CANCEL YOUR AUTOMATIC SUBSCRIPTION RENEWAL, you
        may do so by visiting your account settings page
        (https://aestell.com/auth/login), going to the section called “Settings”
        and clicking on “Change payment type”. Aestell will make reasonable
        efforts to process cancellation requests within two business days from
        the receipt of the cancellation request. All other cancellations are
        required to be made directly through the third party that manages your
        Aestell Subscription.
      </p>
      <p>
        (h) <span class="font-italic">Refund Policy</span>. We will not refund
        any fees paid to us, including any advance charge(s) or payment(s) for
        any subscription term for the Services, unless otherwise required by law
        or the terms of this Agreement.
      </p>
      <p>
        (i) <span class="font-italic">Charge Backs</span>. If you dispute
        Subscription charges with your credit card company or financial
        institution, and Aestell’s investigation determines the charges were
        valid, we may, on reasonable written notice to you, charge to your
        Aestell account the reasonable required cost of responding to your
        charge back request. Aestell’s U.S. Privacy Policy details what
        information Aestell may share with your financial institution as part of
        the investigation into disputed Subscription charges.
      </p>
    </VCardText>
  </VCard>
</template>
<script>
export default {}
</script>
